module.exports = new __parcel__URL__("cow.e41482e6.svg").toString();